
export function getHost(parts: number|null = null) {
  return null === parts ? document.location.hostname : document.location.hostname.split('.').slice(-Math.abs(parts)).join('.')
}
